import { required, helpers } from 'vuelidate/lib/validators';

const itemValidation = {
  minAmount: {
    required,
  },
  maxAmount: {
    required,
    numeric: helpers.regex('numeric', /^[0-9]*$/),
  },
  discount: {
    required,
    numeric: helpers.regex('numeric', /^[0-9]*$/),
  },
};

export default itemValidation;